<template>
    <div class="page-search">
        <div class="search-form" v-if="keyword && searchtype!=2">
            <div class="tip" v-if="!loading.show">
                <div>在藏书阁中, 找到{{ totalNum }}条与<span class="red">“{{ word }}”</span>相关的结果</div>
                <el-button type="primary" size="mini" @click="download" icon="el-icon-download">下载</el-button>
            </div>
        </div>
        <div class="search-form" v-else>
            <div class="search-form-item">
                <span class="label">摘录:</span>
                <perfect-scrollbar class="pc" :options="{ suppressScrollY: true }">
                    <u-checkbox :list="books" v-model="bookId" @change="onSearch" />
                </perfect-scrollbar>
                <u-checkbox class="sj" :list="books" v-model="bookId" @change="onSearch" />
            </div>
            <div class="search-form-item">
                <span class="label">拼音:</span>
                <perfect-scrollbar class="pc" :options="{ suppressScrollY: true }">
                    <u-checkbox :list="pys" v-model="pinyin" @change="onSearch" />
                </perfect-scrollbar>
                <u-checkbox class="sj" :list="pys" v-model="pinyin" @change="onSearch" />
            </div>
            <div class="search-form-item">
                <span class="label">标签:</span>
                <perfect-scrollbar class="pc" :options="{ suppressScrollY: true }">
                    <u-checkbox :list="tags" v-model="bookTypeName" @change="onSearch" />
                </perfect-scrollbar>
                <u-checkbox class="sj" :list="tags" v-model="bookTypeName" @change="onSearch" />
            </div>
        </div>

        <!-- <div class="totalNum" v-if="totalNum"><span class="red">{{ totalNum }}</span>项</div> -->

        <div class="list">
            <el-row :gutter="50" v-if="bookList.length">
                <template v-if="keyword && searchtype!=2">
                    <el-col :sm="24" v-for="(item, index) in bookList" :key="index">
                        <div class="list-item book-search">
                            <div class="biao-ti" @click="onItem2(item)"
                                v-html="common.batchHighlightKeyword(item.biaoTi, word)"></div>
                            <div class="nei-rong" @click="onItem2(item)"
                                v-html="common.batchHighlightKeyword(item.neiRong, word)"></div>
                            <a class="book-name" @click="onItem(item)"
                                v-html="common.batchHighlightKeyword(item.bookName, word)"></a>
                        </div>
                    </el-col>
                </template>
                <template v-else>
                    <el-col :sm="12" :md="6" v-for="(item, index) in bookList" :key="index">
                        <a class="list-item" @click="onItem(item)">
                            <span v-html="common.batchHighlightKeyword(item.bookName, word)"></span>
                        </a>
                    </el-col>
                </template>
            </el-row>
            <el-empty v-else-if="!loading.show" description="暂无数据"></el-empty>
        </div>

        <el-pagination class="pc" @size-change="sizeChange" @current-change="currentChange" :current-page.sync="pageIndex"
            :page-sizes="[20, 40, 80, 100, 200, 300, 400, 500, 1000]" :page-size="pageSize"
            layout="total, prev, pager, next, sizes" :total="totalNum">
        </el-pagination>
        <el-pagination class="sj" @size-change="sizeChange" @current-change="currentChange" :current-page.sync="pageIndex"
            layout="prev, pager, next " :page-size="pageSize" :total="totalNum">
        </el-pagination>
    </div>
</template>

<script>
import UCheckbox from '@/components/uCheckbox.vue';
import { mapGetters } from 'vuex';
export default {
    props: {
        keyword: {
            type: String,
            default: "",
        },
    },
    computed: {
        ...mapGetters(["loading"]),
        word() {
            if (this.keyword) {
                let obj = this.common.parseUrlParams(this.keyword);
                return obj.keyword;
            } else {
                return "";
            }
        },
        searchtype() {
            if (this.keyword) {
                let obj = this.common.parseUrlParams(this.keyword);
                return obj.searchtype;
            } else {
                return "1";
            }
        }
    },
    components: {
        UCheckbox,
    },
    watch: {
        keyword() {
            this.init();
        }
    },
    data() {
        return {
            drugName: '', // 药品名称 
            bookTypeName: [], // 书名类别名称
            pageIndex: 1, // 页码 
            pageSize: 100, // 页大小 
            pinyin: [], // 拼音码 

            totalNum: 100,
            bookId: [],
            books: [
                {
                    label: "中医教材",
                    value: 1,
                },
                {
                    label: "中医著作",
                    value: 5,
                },
                {
                    label: "使用手册",
                    value: 20,
                },
                {
                    label: "西医备考",
                    value: 25,
                },
            ],
            pys: [
                "A",
                "B",
                "C",
                "D",
                "E",
                "F",
                "G",
                "H",
                "I",
                "J",
                "K",
                "L",
                "M",
                "N",
                "O",
                "P",
                "Q",
                "R",
                "S",
                "T",
                "U",
                "V",
                "W",
                "X",
                "Y",
                "Z"
            ],
            tags: [
                "经论",
                "伤寒、金匮",
                "诊治",
                "本草",
                "方言",
                "内科",
                "妇科",
                "儿科",
                "外科",
                "五官",
                "针灸",
                "医论",
                "医案",
                "综合",
                "养生",
                "其他"
            ],
            bookList: [],
        }
    },
    methods: {
        download() {
            // this.common.downloadFile("https://crmtest.cimaizhongyi.com/book/【胃病】查询结果.xls");
            let obj = {
                content: this.word
            }
            this.$store.commit("showLoading")
            this.api("exportBookList", obj).then(res => {
                this.$store.commit("hideLoading")
                this.common.downloadFile(res.result.downloadHttpUrl);
            })
        },
        onItem2(item) {
            this.jump(`/bookDetail/${item.bookId}/${item.id}/${item.bookName}/${this.keyword}`);
        },
        onItem(item) {
            this.jump(`/pageCatalogue/${item.bookId}/${item.bookName}`);
        },
        sizeChange(size) {
            this.pageSize = size;
            this.onSearch();
        },
        onSearch() {
            this.pageIndex = 1;
            this.getData();
        },
        currentChange(index) {
            this.pageIndex = index;
            this.getData();
        },
        getData() {
            this.bookList = [];
            let obj = {
                ascriptionId: this.bookId.join(","), //归属Id(1中医教材 5中医著作 20实用手册 25西医备考)
                // bookTypeName: this.drugName, // 书名类别名称 
                bookTypeName: this.bookTypeName.join(','), // 书名类别名称 
                pageIndex: this.pageIndex, // 页码 
                pageSize: this.pageSize, // 页大小 
                pinyin: this.pinyin.join(','), // 拼音码 
                content: this.word, //内容检索
                searchType: this.word ? this.searchtype : "2", // 搜索类型 1 搜索内容 2 搜索书名
                // content: "测试", //内容检索
                // searchType:  "2", // 搜索类型 1 搜索内容 2 搜索书名
            }
            this.$store.commit("showLoading")
            this.api("listBooks", obj).then(res => {
                this.$store.commit("hideLoading")
                this.totalNum = res.total;
                this.bookList = res.result;
                this.$store.commit("setBookList", this.bookList);
            })
        },
        init() {
            this.drugName = this.keyword;
            this.onSearch();
        }
    },
    created() {
        this.init();


    },
}
</script>

<style lang="scss">
.page-search {
    .tip {
        font-size: 13px;
        color: #666;
        position: relative;

        .el-button {
            position: absolute;
            right: 0;
            bottom: -4px;
        }
    }

    .list .list-item.book-search {
        border-bottom: 1px dotted #ddd;
        padding: 10px 0;

        .nei-rong {
            color: #999;
        }

        .biao-ti,
        .book-name {
            color: #659bc9;
            font-size: 14px;
        }

        .biao-ti {
            font-size: 16px;
            font-weight: bold;
        }
    }
}
</style>